import _some from 'lodash-es/some';
import { ObjectWithClassrooms } from '@teetsh/app/src/types/event';
import { Classroom } from 'types/classroom';
import getClassroomsAvailableForThatDay from '@teetsh/app/src/components/EDT/getClassroomsAvailableForThatDay';
import getDay from '@teetsh/app/src/utils/time/getDay';

export default function filterEdtSeancesWithClassrooms<
  A extends ObjectWithClassrooms,
>(edtSeances: A[], classrooms: Classroom[]): A[] {
  return edtSeances.filter(ev => {
    const classroomsAvailableThatDayIds = (
      getClassroomsAvailableForThatDay(classrooms, getDay(ev.start)) || []
    ).map(c => c.id);
    //  We filter out events that are in a day not worked by the classroom
    return _some(ev.classroomIds, clId =>
      classroomsAvailableThatDayIds.includes(clId),
    );
  });
}
